/* eslint-disable no-console */
require('videojs-contrib-ads');
require('videojs-ima');
import videoAnalytics from '../modules/video-player-analytics';
import $ from 'jquery';
import _ from 'underscore';

class VideoInit {
    constructor() {
        // Set Default Player Options Setup:
        this.options = {
            'autoplay': false,
            'controls': true,
            'height': window.innerHeight,
            'preload': 'auto',
            'width': window.innerWidth
        };
        // Player Initialize:
        this.player = videojs('video-player-embed', this.options);
        window.player = this.player;
        // Other Instance Vars:
        this.video = document.getElementById('video-player-embed_html5_api');

        this.extension = this.video.canPlayType('video/webm') ? 'webm' : 'mp4';
        this.resolution = window.innerWidth > 700 ? '720' : '480';
        this.playlist = [];
        this.adTagUrl = '';
        this.ads = true;
    }

    init() {

        // Set Ad Options
        var options = {
            id: 'video-player-embed',
            adTagUrl: this.buildAdTagUrl()
        };

        // Initialize Ads

        this.player.ima(options, () => {
            this.player.ima.start();
        });

        this.player.ima.requestAds();
        this.player.ima.setShowCountdown(true);

        // Start Player on Watch Pages
        if (window.parent.document.querySelector('.fc-header.-watch')) {
            this.player.play();
        }

        videoAnalytics.on({
            player: this.player
        });

        // Add a data attribute to the iframe to identify it as original video of the playlist, this is accomplished by checking to see if playlistCount is in the url, if not, then it's the original video
        var $originalEmbedDOM = window.parent.$('.video-frame');

        if (!$originalEmbedDOM.length) {
            $originalEmbedDOM = window.parent.$('.fastcoVideoEmbed');
        }

        if ($originalEmbedDOM.attr('src') && $originalEmbedDOM.attr('src').indexOf('playlistCount') === -1) {
            $originalEmbedDOM.data('originalID', this.getVideoID($originalEmbedDOM.attr('src')));
        } else {
            this.player.play();
        }

        // Initialize Playlist
        this.playlistInit(
            () => {
                this.player.on('ended', () => {
                    // For playlist, we need to update the entire iframe with the next video in the playlist
                    // If the url has a query string of playlistCount, then increment it by 1 then use it, otherwise start at 0th element of playlist
                    // The url should be something like this: /embed/41232c84d4580?poster=twistage&pos=inline&veggiemode=1&autoplay=1&playlist=_playlist_4728c8944a361&volumeLevel=0.5&isVideoFromPlayList=1

                    // Get the video iframe URL and establish next video url as base values
                    var originalEmbedUrl = $originalEmbedDOM.attr('src');
                    if (originalEmbedUrl) {
                        var nextVideoUrl = $originalEmbedDOM.attr('src').replace(/embed\/(.*?)\?/i, `embed/${this.playlist[0].url.split('/')[4]}?`) + '&playlistCount=0&autoplay=1';

                        // Increment the count base on video and iframe url and establish next video's url
                        var playlistCounterFromParam = parseInt(this.getPlaylistCount(originalEmbedUrl), 10);
                        if (playlistCounterFromParam || playlistCounterFromParam === 0) {
                            // Replace embed url video ID
                            playlistCounterFromParam = playlistCounterFromParam + 1;
                            nextVideoUrl = originalEmbedUrl.replace(/embed\/(.*?)\?/i, `embed/${this.playlist[playlistCounterFromParam].url.split('/')[4]}?`);

                            // Replace counter value and construct next video URL
                            nextVideoUrl = nextVideoUrl.replace(/&playlistCount=(.*)/g, `&playlistCount=${playlistCounterFromParam}`);
                        }

                        // Set a data attribute for original video id to build the playlist=_playlist_4728c8944a361 part of the embed url
                        if ($originalEmbedDOM.data('originalID')) {
                            // iframe already has original id attribute, then append to next video url
                            nextVideoUrl += '&_playlist_' + $originalEmbedDOM.data('originalID');
                        }

                        // Finally update the iframe url to do playlisting
                        $originalEmbedDOM.attr('src', nextVideoUrl);
                    }
                });
            }
        );
    }

    // Ad Tag Setter
    buildAdTagUrl() {
        // Key Vals
        var keyVals = this._determineCustomParam();
        var keyValString = '';
        _.each(keyVals, function (value, key) {
            keyValString += `&${key}=${value}`;
        });

        // Base:
        var adUrl = 'https://pubads.g.doubleclick.net/gampad/ads?' +
            'sz=640x360' +
            '&impl=s' +
            '&gdfp_req=1' +
            '&env=vp' +
            '&output=vast' +
            '&unviewed_position_start=1' +
            '&vad_type=linear' +
            '&vpos=preroll' +
            // Ad Ops Params:
            '&iu=' + this.getParam('zone') + '/preroll' +
            '&correlator=' + Date.now() +
            // Custom Params:
            // TESTING:
            // '&cust_params=cms%3Ddfp_video_test';
            // PRODUCTION:
            '&cust_params=video_tags%3D' + window.DFPtags + keyValString;
        return adUrl;
    }

    _determineCustomParam() {
        var params = {},
            model = window.parent.bootstrap_obj,
            type = model.type,
            kind = model.kind,
            topic = model.topic,
            supertag = model.supertag,
            tags = model.tags,
            author = model.author,

            keywords = model.keywords;

        if (kind === undefined) {
            params.c_type = type;
        } else {
            params.c_type = kind || '';
        }

        if (typeof Krux !== "undefined") {
            params.ksg = Krux.segments || [];
            params.kuid = Krux.user || '';
        }

        params.scroll = window.bootstrap_obj.infiniteScrollPageNum || 0;

        params.chn = [];
        if (topic && topic.slug) {
            params.chn.push(topic.slug);
        }
        if (supertag && supertag.slug) {
            params.chn.push(supertag.slug);
        }

        //TAGS
        if (tags) {
            var tagslugs = [];
            $.each(tags, function (index, tag) {
                if (tag.slug) {
                    tagslugs.push(tag.slug);
                }
            });

            if (tagslugs.length) {
                params.tags = tagslugs;
            }
        }

        if (keywords && keywords.socialtags) {

            if (!params.tags) {
                params.tags = [];
            }

            $.each(keywords.socialtags, function (index, keyword) {
                params.tags.push(keyword);
            });

            params.tags = $.unique(params.tags);
        }

        if (params.tags) {
            params.tags = $.unique(params.tags);
        }

        params.slide = (kind === 'slideshow') ? 1 : 0;
        // if (util.get('fastcache')) {
        //     params.login = 'yes'; //(util.get('fastcache') ? 1 : 0);
        // }

        //VIDEO
        params.video = (kind === 'video' || kind === 'watch') ? 'yes' : 'no';

        // If kind is watch set global object _refreshOnVideoChange in order to enable listening to messages
        if (kind === "watch") {
            window._refreshOnVideoChange = true;
        }

        //AUTHOR
        params.aut = ((author && author.name) ? String(author.name).toLowerCase().replace(/\s+/g, '') : '');

        //Switched page level nsfw key/value to adzone
        // params.nsfw = this.ads.nsfw ? 'yes' : 'no';

        // Key val identifier for ad request coming into redesign
        params.abgroup = '1';

        return params;
    }

    sanitizePlaylistItems(nid, playList) {
        // Remove current nid from the playlist
        let sanitizedList = [];
        let matchedIndex = null;
        const nidInt = parseInt(nid, 10);
        $.each(playList, function (index, item) {
            if (item.nid === nidInt) {
                matchedIndex = index;
                return false;
            }
        });

        if (matchedIndex === null) {
            sanitizedList = playList;
        } else {
            // Then split the playlist to [Before the matched ID] and [After the matched ID]
            /*
             [a,b,c,d,e,f,g,h]  <---- item e matches current video id, then the array becomes
             [f,g,h,a,b,c,d]

             */
            let playListLength = playList.length;

            // Clone these variable to prep for splicing
            let playListCopyForFirstHalf = playList.slice(0), playListCopyForSecondHalf = playList.slice(0);

            // Remove anything up to the matching nid
            let firstHalf = playListCopyForFirstHalf.splice(0, matchedIndex);

            //Remove first few elements up to the matched Index item
            let secondHalf = playListCopyForSecondHalf.splice(++matchedIndex, playListLength - matchedIndex);
            sanitizedList = secondHalf.concat(firstHalf);
        }

        return sanitizedList;
    }

    // Get Vars From Containining Window
    getParam(variable) {
        var query = window.location.search.substring(1);

        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (pair[0] === variable) {
                var param = decodeURIComponent(pair[1]);
                return param.replace(/\"|\'/, "");
            }
        }
        return false;
    }

    // parses our playlistcount from a url
    getPlaylistCount(url) {
        var matchedID = url.match(/&playlistCount=(.*)/);
        if (matchedID && matchedID[1]) {
            return matchedID[1];
        }
        return '';
    }

    // Parses video ID from URL
    getVideoID(url) {
        var matchedID = url.match(/embed\/(.*)\?/)[1];
        if (matchedID) {
            return matchedID;
        }
        return '';
    }
    // 1. Check to see if the series is a custom content, using this api: api/v3/modules/check_is_custom?tag=NAME_OF_SUPERTAG
    // 2. If it is a custom, call getPlaylistURLFromSeries() else call getPlaylistURLFromQueue()
    // Example of a NON-Custom Video: http://fastcompany.local:8880/embed/260894d0f167f?watermark=0&autoplay=1&nid=3055097&poster=full&rel=1&kind=watch
    // Example of a Custom Video: http://fastcompany.local:8880/embed/aa964060fe030?watermark=0&autoplay=1&nid=3057622poster=full&rel=1&kind=watch
    playlistInit(fn) {
        const adTags = window.DFPtags || null;
        let supertag = null;

        if (adTags) {
            // Sanitize it by replacing _ with -
            supertag = adTags.split(',')[0].replace(/_/ig, '-');
        }

        if (supertag) {
            $.get('/api/v3/modules/check_is_custom?tag=' + supertag, (result) => {
                if (result && result.status === 200 && result.isCustom === true) {
                    // This is a custom content, call API to get playlist from that series
                    this.getPlaylistURLFromSeries(supertag, fn);
                } else {
                    // Not custom content, retrieve playlist from regular queue
                    this.getPlaylistURLFromQueue(fn);
                }
            });
        } else {
            // No supertag identified, just get regular queue as playlist
            this.getPlaylistURLFromQueue();
        }
    }

    getPlaylistURLFromSeries(supertag, fn) {
        const nid = this.getParam('nid');

        $.get('/api/v3/modules/video_series_playlist?tag=' + supertag, (result) => {
            if (result && result.status === 200 && result.videos) {
                let sanitizedSponsorPlaylist = [];
                let playlistUrls = [];
                sanitizedSponsorPlaylist = this.sanitizePlaylistItems(nid, result.videos);

                _.each(sanitizedSponsorPlaylist, (item) => {
                    playlistUrls.push({
                        url: `//api.twistage.com/videos/${item.videoID}/formats/${this.extension}_${this.resolution}/play.${this.extension}`,
                        title: item.title
                    });
                });
                this.playlist = playlistUrls;
                fn();
            }
        });
    }

    // AJAX Call to Populate Playlist
    getPlaylistURLFromQueue(fn) {
        var request = new XMLHttpRequest();
        var playlist = [];
        // New request
        request.open('GET', '/api/v3/modules/video-playlist', true);
        // Request processing
        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                var data = JSON.parse(request.responseText).response;
                var i = 0;
                const nid = this.getParam('nid');
                var sanitizedSponsorPlaylist = this.sanitizePlaylistItems(nid, data);

                for (i; i < sanitizedSponsorPlaylist.length; i++) {
                    var datum = sanitizedSponsorPlaylist[i];
                    var urlObj = {
                        url: '//api.twistage.com/videos/' + datum.videoID + '/formats/' + this.extension + '_' + this.resolution + '/play.' + this.extension,
                        title: datum.title
                    };
                    playlist.push(urlObj);
                }
                this.playlist = playlist;
                return fn();
            }
            console.error('We reached our target server, but it returned an error');
        }.bind(this);
        // Request error handling
        request.onerror = function () {
            console.error('There was a connection error of some sort');
        };
        // Request initialized
        request.send();
    }

    // Set Listeners
    on() {
        const iOS = (/iPad|iPhone|iPod/).test(navigator.userAgent) && !window.MSStream;
        if (!iOS) {
            return $(window).on('load', this.init.bind(this));
        }
    }
}

export default new VideoInit();
